import { Tabs } from 'antd';
import React from 'react';
import Login from './Login';
import Register from './Register';

function ForumAuth({ setAuth }) {
    return (
        <div style={{
            height: `80vh`,
            display: `flex`,
            justifyContent: `center`,
            alignItems: `start`,
            paddingTop: `100px`
        }}>
            <Tabs
                style={{
                    width: `450px`,
                    borderRadius: `10px`,
                    display: `flex`,
                    justifyContent: `center`,
                    alignItems: `center`,
                    backgroundColor: '#fff',
                    padding: '60px'
                }}
                type="card"
                items={
                    [
                        {
                            label: `Kirish`,
                            key: 1,
                            children: <Login setAuth={setAuth} />,
                        },
                        {
                            label: `Ro'yxatdan o'tish`,
                            key: 2,
                            children: <Register setAuth={setAuth} />,
                        }
                    ]
                }
            />
        </div>
    );
}

export default ForumAuth;